'use client';

import { usePathname } from '@/i18n/routing';
import { Header } from './Header';
import { Footer } from './Footer';

export function LayoutWrapper({ 
  children,
  settings,
  header,
  footer
}: { 
  children: React.ReactNode;
  settings: Record<string, string>;
  header: React.ReactNode;
  footer: React.ReactNode;
}) {
  const pathname = usePathname();
  // Check if it's an admin path. 
  // Next-intl usePathname already strips the locale prefix (e.g., returns '/admin' for '/en/admin')
  const isAdmin = pathname.startsWith('/admin') || pathname === '/admin';

  if (isAdmin) {
    return <main className="min-h-screen bg-gray-100">{children}</main>;
  }

  return (
    <>
      {header}
      <main className="min-h-screen">
        {children}
      </main>
      {footer}
    </>
  );
}
